import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, composeAuth, AuthError } from "../../helpers/utils";
import { logoutUser } from "./account";

export const generateContent = createAsyncThunk(
    "ai/generateContent",
    async (payload, thunkApi) => {
      try {
        const url = process.env.REACT_APP_SERVER + `/api/ai/genrate_report`;
  
        const Authorization = composeAuth(payload?.jwt);
  
        const res = await fetch(url, {
          method: "PATCH",
          headers: {
            "Content-type": "application/json",
            Authorization,
          },
          body: JSON.stringify(payload?.requestBody),
        });
  
        const response = await res.json();
  
        const validateData = checkStatus(response);
        return validateData;
      } catch (err) {
        if (err instanceof AuthError) {
          thunkApi.dispatch(logoutUser());
        }
        return thunkApi.rejectWithValue(err);
      }
    }
  );

export const getGeneratedContent = createAsyncThunk(
    "ai/getGeneratedContent",
    async (payload, thunkApi) => {
      try {
        const url = process.env.REACT_APP_SERVER + `/api/ai/goal/${payload?.moduleId}/schema/${payload?.schemaId}`;
  
        const Authorization = composeAuth(payload?.jwt);
  
        const res = await fetch(url, {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization,
          }
        });
  
        const response = await res.json();
  
        const validateData = checkStatus(response);
        return validateData;
      } catch (err) {
        if (err instanceof AuthError) {
          thunkApi.dispatch(logoutUser());
        }
        return thunkApi.rejectWithValue(err);
      }
    }
  );

export const stopGeneration = createAsyncThunk(
    "ai/stopGeneration",
    async (payload, thunkApi) => {
      try {
        const url = process.env.REACT_APP_SERVER + `/api/ai/goal/stop/${payload?.logId}`;
  
        const Authorization = composeAuth(payload?.jwt);
  
        const res = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization,
          }
        });
  
        const response = await res.json();
  
        const validateData = checkStatus(response);
        return validateData;
      } catch (err) {
        if (err instanceof AuthError) {
          thunkApi.dispatch(logoutUser());
        }
        return thunkApi.rejectWithValue(err);
      }
    }
  );


export const generateTagSummary= createAsyncThunk(
    "ai/generateTagSummary",
    async (payload, thunkApi) => {
      try {
        const url = process.env.REACT_APP_SERVER + `/api/ai/genrate_report_by_tagId`;
  
        const Authorization = composeAuth(payload?.jwt);
  
        const res = await fetch(url, {
          method: "PATCH",
          headers: {
            "Content-type": "application/json",
            Authorization,
          },
          body: JSON.stringify(payload?.requestBody),
        });
  
        const response = await res.json();
  
        const validateData = checkStatus(response);
        return validateData;
      } catch (err) {
        if (err instanceof AuthError) {
          thunkApi.dispatch(logoutUser());
        }
        return thunkApi.rejectWithValue(err);
      }
    }
  );

  export const getGeneratedTagSummary = createAsyncThunk(
    "ai/getGeneratedTagSummary",
    async (payload, thunkApi) => {
      try {
        const url = process.env.REACT_APP_SERVER + `/api/ai/goal/tag/${payload?.tagId}`;
  
        const Authorization = composeAuth(payload?.jwt);
  
        const res = await fetch(url, {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization,
          }
        });
  
        const response = await res.json();
        const validateData = checkStatus(response);
        return validateData;
      } catch (err) {
        if (err instanceof AuthError) {
          thunkApi.dispatch(logoutUser());
        }
        return thunkApi.rejectWithValue(err);
      }
    }
  );


  export const stopTagSummaryGeneration = createAsyncThunk(
    "ai/stopGeneration",
    async (payload, thunkApi) => {
      try {
        const url = process.env.REACT_APP_SERVER + `/api/ai/goal/stop/${payload?.logId}`;
  
        const Authorization = composeAuth(payload?.jwt);
  
        const res = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization,
          }
        });
  
        const response = await res.json();
  
        const validateData = checkStatus(response);
        return validateData;
      } catch (err) {
        if (err instanceof AuthError) {
          thunkApi.dispatch(logoutUser());
        }
        return thunkApi.rejectWithValue(err);
      }
    }
  );